import * as logger from '@owl-nest/logger'
import * as env from '@owl-nest/config'

type Response = {
  redirect_url: string
  status: number
}

export async function updateSettings(formData: BodyInit): Promise<Response> {
  if (!formData) {
    return Promise.reject('formData argument is required')
  }

  return fetch(`${env.ULULE_ORIGINS.fr}/metasettings/dashboard/`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json, application/xml, text/plain, text/html, *.*',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {
      if (error.status === 200) {
        // False alert.
        return
      }
      logger.err('[user] failed to update meta settings', { error })
    })
}
